export const AUTH = {
  pinDigit: (i) => `pin-digit-${i}`,
  pinKey: (n) => `pin-key-${n}`,
  pinBackspace: "pin-backspace",
  pinSubmit: "pin-submit",
  pinError: "pin-error",
};

export const NAV = {
  dashboard: "nav-dashboard",
  devices: "nav-devices",
  personas: "nav-personas",
  videos: "nav-videos",
  schedule: "nav-schedule",
  streams: "nav-streams",
  warmup: "nav-warmup",
  comments: "nav-comments",
  accounts: "nav-accounts",
  proxies: "nav-proxies",
  logs: "nav-logs",
  analytics: "nav-analytics",
  alerts: "nav-alerts",
  settings: "nav-settings",
  logout: "nav-logout",
};

export const DASHBOARD = {
  root: "dashboard-root",
  kpiCard: (k) => `kpi-${k}`,
  deviceTile: (id) => `device-tile-${id}`,
  seedBtn: "dashboard-seed-btn",
};

export const DEVICES = {
  root: "devices-root",
  addBtn: "device-add-btn",
  pingBtn: (id) => `device-ping-${id}`,
  editBtn: (id) => `device-edit-${id}`,
  deleteBtn: (id) => `device-delete-${id}`,
  saveBtn: "device-save-btn",
  form: {
    name: "device-form-name",
    model: "device-form-model",
    color: "device-form-color",
    ios: "device-form-ios",
    udid: "device-form-udid",
  },
};

export const PERSONAS = {
  root: "personas-root",
  createBtn: "persona-create-btn",
  aiGenerateBtn: "persona-ai-generate-btn",
  aiRefreshBtn: (id) => `persona-ai-refresh-${id}`,
  editBtn: (id) => `persona-edit-${id}`,
  deleteBtn: (id) => `persona-delete-${id}`,
  saveBtn: "persona-save-btn",
};

export const VIDEOS = {
  root: "videos-root",
  addBtn: "video-add-btn",
  uploadInput: "video-upload-input",
  uploadTrigger: "video-upload-trigger",
  aiCaptionBtn: "video-ai-caption-btn",
  editBtn: (id) => `video-edit-${id}`,
  deleteBtn: (id) => `video-delete-${id}`,
  queueBtn: (id) => `video-queue-${id}`,
  playBtn: (id) => `video-play-${id}`,
  saveBtn: "video-save-btn",
  player: "video-player",
  playerClose: "video-player-close",
  bulkTrigger: "video-bulk-trigger",
  bulkDropzone: "video-bulk-dropzone",
  bulkInput: "video-bulk-input",
  bulkStart: "video-bulk-start",
  bulkClose: "video-bulk-close",
  bulkAccount: "video-bulk-account",
  bulkClear: "video-bulk-clear",
  bulkItem: (idx) => `video-bulk-item-${idx}`,
  bulkItemStatus: (idx) => `video-bulk-item-status-${idx}`,
  bulkItemRemove: (idx) => `video-bulk-item-remove-${idx}`,
  bulkSummary: "video-bulk-summary",
  ideasTrigger: "video-ideas-trigger",
  ideasAccount: "video-ideas-account",
  ideasGenerate: "video-ideas-generate",
  ideasClose: "video-ideas-close",
  ideasCard: (i) => `video-idea-card-${i}`,
  ideasUseBtn: (i) => `video-idea-use-${i}`,
};

export const SCHEDULE = {
  root: "schedule-root",
  addBtn: "schedule-add-btn",
  saveBtn: "schedule-save-btn",
  markDoneBtn: (id) => `schedule-done-${id}`,
  deleteBtn: (id) => `schedule-delete-${id}`,
};
export const STREAMS = {
  root: "streams-root",
  addBtn: "stream-add-btn",
  createBtn: "stream-create-btn",
  editBtn: (id) => `stream-edit-${id}`,
  deleteBtn: (id) => `stream-delete-${id}`,
  startBtn: (id) => `stream-start-${id}`,
  stopBtn: (id) => `stream-stop-${id}`,
};
export const COMMENTS = {
  root: "comments-root",
  createBtn: "comments-create-btn",
  runBtn: "comments-run-btn",
  saveBtn: "comments-save-btn",
};
export const WARMUP = {
  root: "warmup-root",
  tickBtn: "warmup-tick-btn",
  regenBtn: (id) => `warmup-regen-${id}`,
  advanceBtn: (id) => `warmup-advance-${id}`,
  card: (id) => `warmup-card-${id}`,
};
export const LOGS = { root: "logs-root" };
export const ANALYTICS = { root: "analytics-root" };
export const ALERTS = { root: "alerts-root", ackBtn: (id) => `alert-ack-${id}`, resolveBtn: (id) => `alert-resolve-${id}` };
export const SETTINGS = { root: "settings-root", saveBtn: "settings-save-btn", aiPingBtn: "settings-ai-ping-btn" };
export const ACCOUNTS = {
  root: "accounts-root",
  addBtn: "account-add-btn",
  editBtn: (id) => `account-edit-${id}`,
  deleteBtn: (id) => `account-delete-${id}`,
  reanimateBtn: (id) => `account-reanimate-${id}`,
  timelineBtn: (id) => `account-timeline-${id}`,
  timelineClose: "account-timeline-close",
  saveBtn: "account-save-btn",
  aiAdviceBtn: (id) => `account-ai-advice-${id}`,
  aiAdviceClose: "account-ai-advice-close",
};
export const PROXIES = {
  root: "proxies-root",
  addBtn: "proxy-add-btn",
  editBtn: (id) => `proxy-edit-${id}`,
  deleteBtn: (id) => `proxy-delete-${id}`,
  checkBtn: (id) => `proxy-check-${id}`,
  saveBtn: "proxy-save-btn",
};
